import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

interface LeaderboardModalProps {
  serverAddress: string;
}

const LeaderboardModal: React.FC<LeaderboardModalProps> = ({
  serverAddress,
}) => {
  const [htmlContent, setHtmlContent] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchHtmlContent();
  }, []);

  const fetchHtmlContent = async (): Promise<any> => {
    try {
      const response = await fetch(serverAddress);
      if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.statusText}`);
      }
      const html = await response.text();
      setHtmlContent(html);
      // eslint-disable-next-line unicorn/catch-error-name
    } catch {
      setHtmlContent(null);
    }
  };

  const onHideModal = (): void => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <button
        className="btn btn-secondary nowrap mt-32 w-100"
        onClick={(): void => setIsModalOpen(true)}
        disabled={!htmlContent}
      >
        <i className="fa fa-table pointer mr-8" />
        View Leaderboard
      </button>

      <Modal
        show={isModalOpen}
        backdrop="static"
        centered
        onHide={(): void => onHideModal()}
        title="Leaderboard"
        className="leaderboard-modal"
      >
        <Modal.Header className="justify-center">Leaderboard</Modal.Header>
        <Modal.Body>
          <div>
            {htmlContent && (
              <div
                style={{
                  border: '2px solid rgba(199, 242, 255, 0.2)',
                  padding: '10px',
                }}
                dangerouslySetInnerHTML={{ __html: htmlContent }}
              />
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary w-100"
            onClick={(): void => onHideModal()}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LeaderboardModal;
